import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const t = (key, options?) => translate('teachingOrder', key, options);

const RouteGuardModal = () => {
  const classes = useStyles();
  return (
    <Box>
      <Typography className={classes.body}>{t('unsavedChangesText')}</Typography>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  body: {
    fontSize: '18px',
  },
}));

export default RouteGuardModal;
